import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debounce from 'lodash/debounce';

import {Button, ThemeContext} from '../';

export default class Search extends Component {
  static propTypes = {
    className: PropTypes.string,
    shrink: PropTypes.bool,
    searchDelay: PropTypes.number,
    onSearch: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    className: '',
    shrink: false,
    searchDelay: 200,
    placeholder: 'search games',
  };

  constructor(props) {
    super(props);

    const {shrink, searchDelay} = props;

    this.state = {
      isShrink: Boolean(shrink),
    };

    this._onChange = debounce(this._onChange, searchDelay);
  }

  onChange = (e) => {
    const query = e.target.value;
    this._onChange(query);
  }

  _onChange(query) {
    const {onSearch} = this.props;

    onSearch(query);
  }

  toggleSearchBox = () => {
    const {isShrink} = this.state;
    this.setState({isShrink: !isShrink});
    this.input.focus();
  };

  render() {
    const {shrink, placeholder, className} = this.props;
    const {isShrink} = this.state;
    const classes = classNames(
      'search',
      {
        search_shrink: isShrink,
        [className]: Boolean(className),
      }
    );

    return (
      <ThemeContext.Consumer>
        {theme => (
          <div className={classes}>
            <Button
              textColor={theme.primaryColor}
              theme="plain"
              icon="search"
              className="search__icon"
              handler={shrink ? this.toggleSearchBox : null}
              hideOutline
            />
            <input
              name="q"
              className="search__control"
              type="search"
              placeholder={placeholder}
              aria-label="Search"
              onChange={this.onChange}
              ref={(input) => {this.input = input;}}
            />
          </div>
        )}
      </ThemeContext.Consumer>
    );
  }
}
